// Import the functions you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // if using Firestore
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// import { getDatabase } from "firebase/database";   // if using Realtime DB
import { getStorage } from "firebase/storage";

// Firebase config comes from environment variables (see .env.example).
// CRA only exposes vars prefixed with REACT_APP_ to the browser bundle.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredConfigKeys = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
];
const missingConfigKeys = requiredConfigKeys.filter(
  (key) => !firebaseConfig[key]
);

if (missingConfigKeys.length) {
  throw new Error(
    `Missing Firebase env vars for: ${missingConfigKeys.join(", ")}. ` +
      "Copy .env.example to .env and fill in the values, then restart the dev server."
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Choose one (or both) depending on DB
const db = getFirestore(app);
// const db = getDatabase(app); // Realtime Database
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);

let analytics = null;
if (firebaseConfig.measurementId) {
  isSupported()
    .then((supported) => {
      if (supported) analytics = getAnalytics(app);
    })
    .catch(() => {});
}

export { app, auth, provider, db, storage, analytics };
